let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lc0pG")).then(() => parcelRequire('aJeLk'));